export default {
  getLastBestOrderList(state) {
    return state.lastBest.list;
  },

  getLastBestOrderPage: (state) => state.lastBest.page,
  getLastBestOrderTotalPage: (state) => state.lastBest.totalPage,

  getLastBestOrderPageInfo(state) {
    return state.lastBest.pageInfo;
  },

  getMyOrderList: (state) => state.myOrder.list,
  getMyOrderPageInfo: (state) => state.myOrder.pageInfo,

  getDetail: (state) => state.detail
};
